class CatExtension < ApplicationRecord
  belongs_to :category
end
